<button
  mat-raised-button
  color="accent"
  [matBadge]="unreadCount$ | async"
  [matBadgeHidden]="!(unreadCount$ | async)"
  matBadgeSize="small"
  matBadgeColor="accent"
  id="open_support">
  Chat With Support
</button>